import React, { useState, useEffect } from "react";
import SecondsTimePicker from "../TimePicker";

function Index({ set, form, element }) {
  const dayOfWeek = [
    {
      id: 0,
      name: "انتخاب کنید",
    },
    {
      id: "str",
      name: "شنبه",
    },
    {
      id: "sun",
      name: "یکشنبه",
    },
    {
      id: "mon",
      name: "دوشنبه",
    },
    {
      id: "thr",
      name: "سه شنبه",
    },
    {
      id: "wen",
      name: "چهارشنبه",
    },
    {
      id: "thu",
      name: "پنجشنبه",
    },
    {
      id: "frd",
      name: "جمعه",
    },
  ];
  const [state, setstate] = useState({});
  const [list, setlist] = useState([]);

  useEffect(() => {}, []);

  const renderDay = id => {
    let result = "";
    dayOfWeek.map(day => {
      if (day.id == id) {
        result = day.name;
      }
    });
    return result;
  };

  return (
    <>
      <div className="row mb-3">
        <div className="col-md-3">
          <select
            className="form-control"
            onChange={({ target: { value } }) => {
              setstate({ ...state, day: value });
            }}
          >
            {dayOfWeek.map((day, key) => {
              return (
                <option key={key} value={day.id}>
                  {day.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-3">
          <SecondsTimePicker
            form={state}
            setForm={setstate}
            element={{
              key: "start",
              name: "زمان شروع",
            }}
          />
        </div>{" "}
        <div className="col-md-3">
          <SecondsTimePicker
            form={state}
            setForm={setstate}
            element={{
              key: "end",
              name: "زمان پایان",
            }}
          />
        </div>
        <div>
          <button
            className="btn btn-warning text-white"
            onClick={() => {
              let newList = [];
              if (element.key in form) {
                newList = [...form[element.key]];
              }
              newList.push(state);
              set({ ...form, [element.key]: newList });
            }}
          >
            اضافه کردن
          </button>
        </div>
      </div>
      <div className="row">
        {form[element.key] &&
          form[element.key].map((day, key) => {
            return (
              <div className="col-md-2" key={key}>
                <div className="card">
                  <div className="card-body">
                    <h3 className="card-title">{renderDay(day.day)}</h3>
                    <h6>{`${day.start} - ${day.end}`}</h6>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}

export default Index;
